
import { useDispatch, useSelector } from "react-redux"
import styled from "styled-components"
import { useScrollLock } from "../../../hooks/useScrollLock"
import { useEffect, useState } from "react"
import { showModal } from "../../../features/modal/modalSlice"
import { useLocation } from "react-router-dom"
import { handleActiveSelect } from "../../../features/layout/layoutSlice"
import Btn from "../../shared/button/Btn"
import PageTopTitle from "../../shared/PageTopTitle"
import { updateAiTitleActivity } from "../../../features/aiControl/aiControlSlice"

const ModalContainer = styled.div`
    position: fixed;
    top: 0;
    right: 0;
    bottom: 0;
    left: 0;
    background-color: rgba(0,0,0,0.6);
    display: flex;
    justify-content: center;
    align-items: center;
    z-index: 26;

    .modal{
        width: 700px;
        max-height: 600px;
        overflow: auto;
        color: ${({ theme }) => theme.mainTextColor};
        background-color: ${({ theme }) => theme.mainBgColor};
        border-radius: 10px;
        padding: 20px 0;
        display: flex;
        flex-direction: column;
        align-items: center;

        .content{
            width: 100%;
            padding: 30px;
            padding-top: 50px;
            display: flex;
            flex-direction: column;
            align-items: center;
            gap: 50px;

            .activity-container{
                width: auto;
                padding: 20px;
                border: solid 2px ${({borderColor}) => borderColor ? "var(--color-green)" : "var(--color-main)"};
                border-radius: 10px;
                display: flex;
                align-items: center;
                gap: 15px;
                font-size: var(--font-size-sm);
                font-weight: var(--font-weight-lg);
                cursor: pointer;

                .top{
                    background-color: ${({borderColor}) => borderColor ? "var(--color-green)" : "var(--color-main)"};
                    width: 12px;
                    height: 12px;
                    border-radius: 50%;
                }

                .name{
                }

                .status{

                }

            }
        }
    }
`
const UpdateAiChatTitleActivityModal = () => {

    const dispatch = useDispatch()
    const location = useLocation()

    const {modalLocation } = useSelector(state => state.modal)
    const {aiTitleData} = useSelector(state => state.aiControl)

    const { lockScroll, unlockScroll } = useScrollLock();

    const [status, setStatus] = useState(aiTitleData.isActive)

    //! bu modal açıldığnda ekran ı lock lamak için
    useEffect(() => {
        lockScroll()

        return () => {
            unlockScroll()
        }
    }, [lockScroll, unlockScroll])


    //! bu başka bir sayfaya geçildiğinde modal ı kapatmak için
    useEffect(() => {
        if (location.pathname !== modalLocation) {
            dispatch(showModal(null))
        }
    }, [dispatch, location.pathname, modalLocation])

    const handleClick = () => {
        dispatch(updateAiTitleActivity({
            isActive: status,
            titleId: aiTitleData.id
        }))
    }


  return (
    <ModalContainer onClick={()=> dispatch(showModal(null))} borderColor={status}>
        <div className="modal"  onClick={(e)=> {e.stopPropagation(); dispatch(handleActiveSelect(null))}}>
            <PageTopTitle title={"Başlık Aktivite Ayarla"}/>
            <div className="content">
                <div className="activity-container" onClick={()=> setStatus((prev) => !prev)}>
                    <div className="top"/>
                    <div className="name">{aiTitleData.titleName}</div>
                    <div className="status">{status ? "Aktif" : "Pasif"}</div>
                </div>
                <Btn width={"200px"} bgColor="#E85446" color="#fff" handleClick={handleClick}>Kaydet</Btn>
            </div>
        </div>
    </ModalContainer>
  )
}

export default UpdateAiChatTitleActivityModal